<!--
 * @Date: 2023-08-17 11:27:53
 * @LastEditors: wuyanfeiying
 * @desc: 重构因子弹窗中，历史记录 模板（包含：最近记录/制表记录）
-->
<template>
  <div class="history-log">
    <!-- tabs 切换 -->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="最近记录" name="record"></el-tab-pane>
      <el-tab-pane label="制表记录" name="table"></el-tab-pane>
    </el-tabs>
    <!-- 功能按钮区域 -->
    <div class="log-btns">
      <div >
        <el-button
          v-if="
            activeName === 'record' &&
              recordLastItem.is_commit &&
              (!recordLastItem.index_info ||
                !recordLastItem.index_info.is_asset)
          "
          size="mini"
          :disabled="!recordLastItem._id"
          @click="addFactorItem(recordLastItem)"
          ><span class="iconfont icon-lyyinyongshuju log-btns-icon"></span>&nbsp;<span
            >引用数据</span
          ></el-button
        >
        <el-button size="mini"  :disabled="!recordLastItem._id" @click="addTextarea(recordLastItem)"
          ><span class="iconfont icon-lyhuitiangongshi log-btns-icon"></span>&nbsp;<span
            >回填公式</span
          ></el-button
        >

        <el-button
          v-if="recordLastItem.is_commit && activeName === 'record'"
          size="mini"
          :disabled="!recordLastItem._id"
          @click="goDailyBack(recordLastItem)"
          ><span class="iconfont icon-lyjiaruhuice log-btns-icon"></span>&nbsp;<span
            >加入回测</span
          ></el-button
        >

        <el-button v-if="!recordLastItem.is_commit&&recordLastItem._id" size="mini"  @click="save"
          ><span class="iconfont icon-lybaocunyinzi log-btns-icon"></span>&nbsp;<span>{{
            !recordLastItem.is_matrix ? "保存因子" : "保存表格"
          }}</span></el-button
        >
      </div>
      <el-tooltip content="清空所有未提交的临时记录" placement="top">
        <el-button type="danger" plain icon="el-icon-delete" size="mini" @click="multiDel">清空未提交</el-button>
      </el-tooltip>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'HistoryLog',

  props: {
    recordActive: { type: String, default: 'record' },
    recordLastItem: { type: Object, default: () => ({}) }
  },

  data () {
    return {
      activeName: this.recordActive
    }
  },

  methods: {
    recordFactorList (value) {
      this.$emit('recordFactorList', value)
    },

    handleClick (tab) {
      console.log(
        '🚀 ~ file: HistoryLog.vue:43 ~ handleClick ~ tab:',
        tab.name
      )
      this.$emit('update:recordActive', tab.name)
      this.recordFactorList(tab.name)
    },

    addFactorItem (value) {
      this.$emit('addFactorItem', value)
    },

    addTextarea (value) {
      this.$emit('addTextarea', value)
    },

    goDailyBack (value) {
      this.$emit('goDailyBack', value)
    },

    save () {
      this.$emit('save')
    },

    multiDel () {
      this.$emit('multiDel')
    }
  }
}
</script>

<style scoped>
.history-log-tabs {
  display: flex;
  margin: 15px 0;
}
.history-log-line {
  margin: 3px;
  background-color: #a30013;
  border-radius: 2px;
  width: 4px;
  height: 16px;
}
.history-log-tabs-item {
  font-weight: bold;
  font-size: 14px;
  margin-left: 10px;
}
.log-tabs-item--active {
  color: #a30013;
}

.log-btns {
  width: 100%;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0px 5px 10px;
}
.log-btns-icon{
  font-size:12px;
}
</style>



// WEBPACK FOOTER //
// src/components/allPage/reconstructionItem/HistoryLog.vue